import apiRequest from '@/js/helpers/apiRequest';
import formattedError from '@/js/utils/formattedError';
import { buildElement } from '@/js/utils/processingOpenApi';

/**
 * Возвращает сессионные данные пользователя
 * @param {Object} dataParams
 * @param {boolean} [dataParams.isGetUserStats=false]
 * @param {boolean} [dataParams.isGetUserLoyalty=false]
 * @param {boolean} [dataParams.isServer=false] - происходит ли запрос на сервере
 * @return {Promise<unknown>}
 */
export default (dataParams = {}) => new Promise((resolve, reject) => {
  const {
    isGetUser = true,
    isGetUserStats = false,
    isGetUserSubscription = false,
    isGetUserSubscriptionRubric = false,
    isGetUserLoyalty = false,
  } = dataParams;

  const include = [];
  if (isGetUser) include.push('user');
  if (isGetUserStats) include.push('user.userStats');
  if (isGetUserSubscription) include.push('user.subscription');
  if (isGetUserSubscriptionRubric) include.push('user.subscription.rubric');
  if (isGetUserLoyalty) include.push('user.userLoyalty');

  const dataRequest = {};
  if (include.length) dataRequest.include = include.join(',');

  return apiRequest.get('/internal/user-session/', dataRequest)
    .then(({ data: dataRes }) => {
      const resFormatted = { ...buildElement(dataRes) };
      let res = { sessionId: resFormatted.id };
      if (resFormatted.relationships?.user) {
        res = {
          ...res,
          ...resFormatted.relationships.user,
        };
      }
      resolve(res);
    })
    .catch((error) => {
      if (error.status) {
        const errors = formattedError(error.data);
        // знаем точно что ожидаем одну ошибку
        const [firstError] = errors;
        return reject(firstError);
      }
      return reject(error);
    });
});

